import { render, staticRenderFns } from "./ContestGroupPreviewsTable.vue?vue&type=template&id=b84cfd2e&scoped=true&"
import script from "./ContestGroupPreviewsTable.vue?vue&type=script&lang=js&"
export * from "./ContestGroupPreviewsTable.vue?vue&type=script&lang=js&"
import style0 from "./ContestGroupPreviewsTable.vue?vue&type=style&index=0&id=b84cfd2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84cfd2e",
  null
  
)

export default component.exports